import PopupManager from "element-ui/lib/utils/popup/popup-manager";
// The customized o-select/o-cascader poppers under components/element-ui use their own
// bundled popup-manager instance, separate from element-ui/lib's. Both counters must be
// lifted past a high-z-index drawer or those dropdowns render behind it (FRO-11094).
import OmniPopupManager from "../../components/element-ui/utils/popup/popup-manager";
import { findHighestZIndex } from "../../utils/util";

export interface IDrawerModel {
    componentName: string;
    props?: Object;
    title?: string;
    subTitle?: string;
    context?: string;
    zIndex?: number;
    showSaveBtn?: boolean;
    actionLabel?: string;
}

export class DrawerModel implements IDrawerModel {
    componentName: string;
    props?: Object;
    title?: string;
    subTitle?: string;
    context?: string;
    zIndex?: number;
    showSaveBtn?: boolean;
    actionLabel?: string;

    constructor(option: IDrawerModel) {
        this.componentName = option.componentName;
        this.props = option.props || {};
        this.title = option.title || null;
        this.context = option.context || null;
        this.zIndex = option.zIndex || Math.max(
            findHighestZIndex('el-dialog__wrapper'),
            findHighestZIndex('omni-drawer')
        ) + 1;
        this.showSaveBtn = option.showSaveBtn || false;
        this.actionLabel = option.actionLabel || null;
        this.subTitle = option.subTitle || null;

        // Element-UI poppers (selects, tooltips, dropdowns) opened from inside this drawer
        // must stack above it. PopupManager.zIndex is a monotonic counter — lift it past this
        // drawer. Two independent counters exist (element-ui/lib + the bundled components/element-ui
        // copy used by o-select/o-cascader); lift both or those dropdowns render behind a
        // high-z-index drawer such as the enquiry webview's (FRO-11094).
        [PopupManager, OmniPopupManager].forEach((manager) => {
            if (manager.zIndex <= this.zIndex) {
                manager.zIndex = this.zIndex + 1;
            }
        });
    }
}